"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles = function (_theme) { return ({
    productCard: {
        'width': 250,
        '&:hover': {
            boxShadow: '0 0 12px rgba(0,0,0,0.5)'
        }
    },
    infoBlock: {
        justifyContent: 'space-between',
        padding: 10
    },
    bookshelfCardLink: {
        'textDecoration': 'none',
        '&:hover': {
            textDecoration: 'none',
        }
    },
    productName: {
        height: 40,
        overflow: 'hidden',
    },
    courseOrAuthor: {
        height: 22,
        overflow: 'hidden'
    }
}); };
exports.default = styles;
